import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import ADACheckbox from '../ADACheckbox';
import HashLink from '../HashLink';

class AdHocReport extends ChemComponent {
	constructor(props) {
		super(props);
		
		var search = {
			JOB_CREATED_FROM: null,
			JOB_CREATED_TO: null,
			TX_ENTERED_FROM: null,
			TX_ENTERED_TO: null,
			STATUS_ID: null,
			SHOP_ID: null,
			PROJECT_ID: null,
			PI_NAME: null,
			CUSTOMER_NAME: null,
			EMP_ID: null,
			JOB_ID: '',
			DESCRIPTION: '',
			SPEEDTYPE: '',
			COMMENT: '',
			TRANSFERRED: null,
			DATE_BILLED: null,
			SUB_TOTAL_ONLY: false,
			ORDER_BY: ['JOB_ID desc']
		};
		
		// default to detail list
		var adhocListInit = this.copyTable(adhocDetailList);
		adhocListInit.ajax.data = { search: search };
		var exportColumnsInit = this.copyColumns(exportDetailColumns);

		this.state = {
			search: search,
			adhocList: adhocListInit,
			exportColumns: exportColumnsInit,
			showSearch: true,
			searchCount: 0,
			renderKey: 0
		};
	}
	
	viewJob(jobId) {
		this.props.setJobEditable(false);
		this.props.navigate('/Jobtrack/Jobs/' + jobId);
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		var newAdhocList = this.copyTable(search.SUB_TOTAL_ONLY ?
			adhocSubtotalList : adhocDetailList);
		newAdhocList.hold = false;
		newAdhocList.ajax.data = { search: this.copyObject(this.state.search) };
		if (newOrderBy) {
			search.ORDER_BY = this.copyObject(newOrderBy);
			newAdhocList.ajax.data.ORDER_BY = this.copyObject(newOrderBy);
		}
		var newExportColumns = this.copyColumns(search.SUB_TOTAL_ONLY ?
			exportSubtotalColumns : exportDetailColumns);
		
		this.mergeState({
			search: search,
			adhocList: newAdhocList,
			exportColumns: newExportColumns,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'AdHocReport',
			columns: this.state.exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Ad Hoc Report</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={adhocSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={5}>
						{this.state.showSearch && <ADACheckbox className="float-end" style={{ paddingTop: '8px', paddingRight: '20px' }}
							checked={this.state.search.SUB_TOTAL_ONLY} label={'Show Sub Total Only'}
							onClick={(event) => this.onChangeSearch('SUB_TOTAL_ONLY', event.target.checked)} />}
					  </Col>
					  <Col xs={2}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_AdHocReport' table={this.state.adhocList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const adhocSearch = [
	{ Header: 'Job Created From', accessor: 'JOB_CREATED_FROM', type: 'date', row: 0, col: 0 },
	{ Header: 'Job Created To', accessor: 'JOB_CREATED_TO', type: 'date', row: 0, col: 1 },
	{ Header: 'Tx Entered From', accessor: 'TX_ENTERED_FROM', type: 'date', row: 0, col: 2 },
	{ Header: 'Tx Entered To', accessor: 'TX_ENTERED_TO', type: 'date', row: 0, col: 3 },
	{ Header: 'Status', accessor: 'STATUS_ID', type: 'select', row: 1, col: 0,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS_SELECT_VW', order: 'STATUS_NAME' }},
	{ Header: 'Shop', accessor: 'SHOP_ID', type: 'select', row: 1, col: 1,
		options: { value: 'SHOP_ID', label: 'SHOP_DETAILS', entity: 'RECHARGES.ADHOC_SHOP_SELECT_VW', order: 'SHOP_ID' }},
	{ Header: 'Project', accessor: 'PROJECT_ID', type: 'select', row: 1, col: 2,
		options: { value: 'PROJECT_ID', label: 'PROJECT_NAME', entity: 'RECHARGES.ADHOC_PROJECT_SELECT_VW', order: 'PROJECT_ID desc' }},
	{ Header: 'PI', accessor: 'PI_NAME', type: 'select', row: 1, col: 3,
		options: { value: 'PI_NAME', label: 'PI_NAME', entity: 'RECHARGES.ADHOC_PI_SELECT_VW', order: 'PI_NAME' }},
	{ Header: 'Customer', accessor: 'CUSTOMER_NAME', type: 'select', row: 2, col: 0,
		options: { value: 'CUSTOMER_NAME', label: 'CUSTOMER_NAME', entity: 'RECHARGES.ADHOC_CUST_SELECT_VW', order: 'CUSTOMER_NAME' }},
	{ Header: 'Employee', accessor: 'EMP_ID', type: 'select', row: 2, col: 1,
		options: { value: 'EMP_ID', label: 'EMP_NAME', entity: 'RECHARGES.ADHOC_EMP_SELECT_VW', order: 'EMP_NAME' }},
	{ Header: 'Job ID (starts with)', accessor: 'JOB_ID', row: 2, col: 2 },
	{ Header: 'Description (contains)', accessor: 'DESCRIPTION', row: 2, col: 3 },
	{ Header: 'Speedtype (contains)', accessor: 'SPEEDTYPE', row: 3, col: 0 },
	{ Header: 'Comment (contains)', accessor: 'COMMENT', row: 3, col: 1 },
	{ Header: 'Transferred', accessor: 'TRANSFERRED', type: 'select', row: 3, col: 2,
		options: [{ value: null, label: 'Select...' },{ value: 'N', label: 'Not Transferred' },{ value: 'Y', label: 'Transferred' }]},
	{ Header: 'Billed', accessor: 'DATE_BILLED', type: 'select', row: 3, col: 3,
		options: { value: 'DATE_BILLED', label: 'DATE_BILLED', entity: 'RECHARGES.ADHOC_BILLED_SELECT_VW', order: 'DATE_BILLED desc' }}	
];

const adhocDetailList = {
	ajax: {
		url: '/JobTrack/AdHocReport',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	hold: true,
	columns: [
		{ Header: 'Job ID', accessor: 'JOB_ID', width: 125 },
		{ Header: 'Line ID', accessor: 'LINE_ID', width: 125 },
		{ Header: 'Job Description', accessor: 'JOB_REF', width: 300 },
		{ Header: 'Shop', accessor: 'SHOP_NAME', width: 125 },
		{ Header: 'Entered', accessor: 'ENTERED', width: 125 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 125 },
		{ Header: 'Job Date', accessor: 'JOB_DATE', width: 125 },
		{ Header: 'Customer', accessor: 'CUSTOMER_NAME', width: 125 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 125 },
		{ Header: 'Percentage', accessor: 'PERCENT', width: 125 },
		{ Header: 'Status', accessor: 'STATUS_NAME', width: 125 },
		{ Header: 'Estim. Labor', accessor: 'ESTIMATED_LABOR', width: 125 },
		{ Header: 'Employee', accessor: 'EMPLOYEE_NAME', width: 125 },
		{ Header: 'Labor hrs', accessor: 'LABOR_TIME', width: 125 },
		{ Header: '$/hr', accessor: 'LABOR_COST', width: 125 },
		{ Header: 'Estim. Material', accessor: 'ESTIMATED_MAT', width: 125 },
		{ Header: 'Material Desc', accessor: 'PART_NAME', width: 300 },
		{ Header: 'Material Qty', accessor: 'PART_QTY', width: 125 },
		{ Header: 'Material Unit Cost', accessor: 'PART_COST', width: 125 },
		{ Header: 'Material Total', accessor: 'TOTAL_PART', width: 125 },
		{ Header: 'Billing Status', accessor: 'BILL_STATUS', width: 125 }
	]
};

const adhocSubtotalList = {
	ajax: {
		url: '/JobTrack/AdHocReport',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	hold: true,
	columns: [
		{ Header: '', accessor: 'id', show: false },
		{ Header: 'ID', accessor: 'JOB_ID', width: 60,
			Cell: props => <HashLink onClick={() => props.parent.viewJob(props.value)}>{props.value}</HashLink> },
		{ Header: 'Job Description', accessor: 'DESCRIPTION', width: 300 },
		{ Header: 'Shop', accessor: 'SHOP_NAME', width: 200 },
		{ Header: 'Started', accessor: 'DATE_ENTERED', width: 100 },
		{ Header: 'PI', accessor: 'PI', width: 200 },
		{ Header: 'Customer', accessor: 'CUSTOMER', width: 200 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 110 },
		{ Header: 'Status', accessor: 'JOB_STATUS', width: 100 },
		{ Header: 'Estim. Labor', accessor: 'ESTIMATED_LABOR', width: 70 },
		{ Header: 'Total Labor', accessor: 'TOTAL_LABOR', width: 70 },
		{ Header: 'Labor Billed', accessor: 'TOTAL_BILLED_LABOR', width: 70 },
		{ Header: 'Labor Transferred', accessor: 'TOTAL_TRANS_LABOR', width: 80 },
		{ Header: 'Labor Not Transf.', accessor: 'TOTAL_NOT_TRANSF_LABOR', width: 70 },
		{ Header: 'Estim. Material', accessor: 'ESTIMATED_MAT', width: 70 },
		{ Header: 'Total Material', accessor: 'TOTAL_MAT', width: 70 },
		{ Header: 'Material Billed', accessor: 'TOTAL_BILLED_MAT', width: 70 },
		{ Header: 'Material Transferred', accessor: 'TOTAL_TRANS_MAT', width: 80 },
		{ Header: 'Material Not Transf.', accessor: 'TOTAL_NOT_TRANSF_MAT', width: 70 },
	]
};

const exportDetailColumns = [
	{ Header: 'Job ID', accessor: 'JOB_ID', width: 25 },
	{ Header: 'Line ID', accessor: 'LINE_ID', width: 25 },
	{ Header: 'Job Description', accessor: 'JOB_REF', width: 60 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 25 },
	{ Header: 'Entered', accessor: 'ENTERED', width: 25 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 25 },
	{ Header: 'Job Date', accessor: 'JOB_DATE', width: 25 },
	{ Header: 'Customer', accessor: 'CUSTOMER_NAME', width: 25 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 25 },
	{ Header: 'Percentage', accessor: 'PERCENT', width: 25 },
	{ Header: 'Status', accessor: 'STATUS_NAME', width: 25 },
	{ Header: 'Estim. Labor', accessor: 'ESTIMATED_LABOR', width: 25 },
	{ Header: 'Employee', accessor: 'EMPLOYEE_NAME', width: 25 },
	{ Header: 'Labor hrs', accessor: 'LABOR_TIME', width: 25 },
	{ Header: '$/hr', accessor: 'LABOR_COST', width: 25 },
	{ Header: 'Estim. Material', accessor: 'ESTIMATED_MAT', width: 25 },
	{ Header: 'Material Desc', accessor: 'PART_NAME', width: 60 },
	{ Header: 'Material Qty', accessor: 'PART_QTY', width: 25 },
	{ Header: 'Material Unit Cost', accessor: 'PART_COST', width: 25 },
	{ Header: 'Material Total', accessor: 'TOTAL_PART', width: 25 },
	{ Header: 'Billing Status', accessor: 'BILL_STATUS', width: 25 }
];

const exportSubtotalColumns = [
	{ Header: 'ID', accessor: 'JOB_ID', width: 12 },
	{ Header: 'Job Description', accessor: 'DESCRIPTION', width: 60 },
	{ Header: 'Shop', accessor: 'SHOP_NAME', width: 40 },
	{ Header: 'Started', accessor: 'DATE_ENTERED', width: 20 },
	{ Header: 'PI', accessor: 'PI', width: 40 },
	{ Header: 'Customer', accessor: 'CUSTOMER', width: 40 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 22 },
	{ Header: 'Status', accessor: 'JOB_STATUS', width: 20 },
	{ Header: 'Estim. Labor', accessor: 'ESTIMATED_LABOR', width: 14 },
	{ Header: 'Total Labor', accessor: 'TOTAL_LABOR', width: 14 },
	{ Header: 'Labor Billed', accessor: 'TOTAL_BILLED_LABOR', width: 14 },
	{ Header: 'Labor Transferred', accessor: 'TOTAL_TRANS_LABOR', width: 16 },
	{ Header: 'Labor Not Transf.', accessor: 'TOTAL_NOT_TRANSF_LABOR', width: 14 },
	{ Header: 'Estim. Material', accessor: 'ESTIMATED_MAT', width: 14 },
	{ Header: 'Total Material', accessor: 'TOTAL_MAT', width: 14 },
	{ Header: 'Material Billed', accessor: 'TOTAL_BILLED_MAT', width: 14 },
	{ Header: 'Material Transferred', accessor: 'TOTAL_TRANS_MAT', width: 16 },
	{ Header: 'Material Not Transf.', accessor: 'TOTAL_NOT_TRANSF_MAT', width: 14 },
];

export default withRouter(AdHocReport);
